// extracted by mini-css-extract-plugin
module.exports = {"swatch":"ColorPicker_swatch__2ipyO","color":"ColorPicker_color__cXLvH","popover":"ColorPicker_popover__3aG6z"};